import React from 'react';
import { SafeAreaView, StyleSheet } from 'react-native';
import Header from './Header';
import { StatusBar } from 'expo-status-bar';

const HeaderWithSatatusBar = ({headerText = 'LOGO', drawerIconVisible =true, userBalance, balfetching}) => {
  return (
    <SafeAreaView>
     <StatusBar backgroundColor="#f0df21" style="dark" translucent={false}/>
       <Header headerText={headerText} drawerIconVisible={drawerIconVisible} userBalance={userBalance} balfetching={balfetching}/>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {

  },
});

export default HeaderWithSatatusBar;